/* Search overlay — debounced predictive results rendered by Shopify.
   The header search link still works with JS off; it just goes to /search. */
(function () {
  'use strict';

  var html = document.documentElement;
  var overlay = document.querySelector('[data-wn-search]');
  if (!overlay) return;

  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-search-results]');
  var idle = overlay.querySelector('[data-search-idle]');
  var clear = overlay.querySelector('[data-search-clear]');
  var timer;
  var lastQuery = '';
  var controller;

  function open() {
    html.setAttribute('data-search-open', 'true');
    window.setTimeout(function () { try { input.focus(); } catch (e) {} }, 260);
  }

  function close() { html.setAttribute('data-search-open', 'false'); }

  function reset() {
    input.value = '';
    lastQuery = '';
    results.innerHTML = '';
    if (idle) idle.hidden = false;
    if (clear) clear.hidden = true;
    input.focus();
  }

  function render(markup) {
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var source = parsed.querySelector('[data-psr]');
    results.innerHTML = source ? source.outerHTML : '';
  }

  function search(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url = '/search/suggest?q=' + encodeURIComponent(query) +
              '&resources[type]=product,collection,page,article' +
              '&resources[limit]=8' +
              '&resources[limit_scope]=each' +
              '&section_id=wn-predictive';

    results.innerHTML = '<p class="wn-so__loading">Searching</p>';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (markup) { render(markup); })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        results.innerHTML = '';
      });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (clear) clear.hidden = q === '';
    window.clearTimeout(timer);

    if (q.length < 2) {
      results.innerHTML = '';
      if (idle) idle.hidden = false;
      lastQuery = '';
      return;
    }
    if (idle) idle.hidden = true;
    if (q === lastQuery) return;

    timer = window.setTimeout(function () {
      lastQuery = q;
      search(q);
    }, 240);
  });

  // Enter goes to the full results page.
  overlay.addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.wn-header__actions a[href$="/search"], [data-search-open-btn]');
    if (trigger) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]') || e.target.closest('[data-search-scrim]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-search-clear]')) { e.preventDefault(); reset(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && html.getAttribute('data-search-open') === 'true') close();

    // Slash focuses search, the way people expect on a site they use often.
    if (e.key === '/' && html.getAttribute('data-search-open') !== 'true') {
      var tag = document.activeElement && document.activeElement.tagName;
      if (tag !== 'INPUT' && tag !== 'TEXTAREA') { e.preventDefault(); open(); }
    }
  });

  // Arrow keys walk the product results.
  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var items = results.querySelectorAll('.wn-psr__item');
    if (!items.length) return;
    e.preventDefault();
    var current = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('aria-selected') === 'true') { current = i; break; }
    }
    if (current > -1) items[current].setAttribute('aria-selected', 'false');
    var nextIndex = e.key === 'ArrowDown' ? current + 1 : current - 1;
    if (nextIndex < 0) nextIndex = items.length - 1;
    if (nextIndex >= items.length) nextIndex = 0;
    items[nextIndex].setAttribute('aria-selected', 'true');
    items[nextIndex].focus();
  });
})();